import {
  BaseActionType,
  SIGN_IN_SILENT_SUCCESS,
  SIGN_IN_SUCCESS,
  SIGN_OUT_SUCCESS,
} from '../actions/actionTypes'

import { IdentityState } from './initialState'

const initialIdentityState: IdentityState | null = null

export function identityReducer(
  state = initialIdentityState,
  action: BaseActionType,
): IdentityState | null {
  switch (action.type) {
    case SIGN_IN_SUCCESS: {
      return null
    }
    case SIGN_IN_SILENT_SUCCESS: {
      return action.payload as IdentityState
    }
    case SIGN_OUT_SUCCESS: {
      return null
    }
    default:
      return state
  }
}
